"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuiltinWritableAtoms = exports.BuiltinAtoms = void 0;
const ab_test_1 = require("./ab-test");
const app_id_config_1 = require("./app-id-config");
const crawler_1 = require("./crawler");
const csp_scripts_1 = require("./csp-scripts");
const dom_1 = require("./dom");
const i18n_text_1 = require("./i18n-text");
const installed_related_app_1 = require("./installed-related-app");
const locale_1 = require("./locale");
const remix_1 = require("./remix");
const render_config_1 = require("./render-config");
const root_traffic_1 = require("./root-traffic");
const server_context_1 = require("./server-context");
const user_agent_1 = require("./user-agent");
const web_user_1 = require("./web-user");
const additional_scripts_1 = require("./additional-scripts");
const us_pre_ban_state_1 = require("./us-pre-ban-state");
const fallback_gp_to_apk_1 = require("./fallback_gp_to_apk");
__exportStar(require("./ab-test"), exports);
__exportStar(require("./crawler"), exports);
__exportStar(require("./i18n-text"), exports);
__exportStar(require("./locale"), exports);
__exportStar(require("./render-config"), exports);
__exportStar(require("./root-traffic"), exports);
__exportStar(require("./user-agent"), exports);
__exportStar(require("./web-user"), exports);
__exportStar(require("./csp-scripts"), exports);
__exportStar(require("./remix"), exports);
__exportStar(require("./app-id-config"), exports);
__exportStar(require("./server-context"), exports);
__exportStar(require("./dom"), exports);
__exportStar(require("./installed-related-app"), exports);
__exportStar(require("./additional-scripts"), exports);
__exportStar(require("./us-pre-ban-state"), exports);
__exportStar(require("./fallback_gp_to_apk"), exports);
exports.BuiltinAtoms = {
    $I18nText: i18n_text_1.$I18nText,
    $WebUser: web_user_1.$WebUser,
    $RenderConfig: render_config_1.$RenderConfig,
    $Locale: locale_1.$Locale,
    $UserAgent: user_agent_1.$UserAgent,
    $EnterABTest: ab_test_1.$EnterABTest,
    $CurrentABTest: ab_test_1.$CurrentABTest,
    $RootTraffic: root_traffic_1.$RootTraffic,
    $CSPScripts: csp_scripts_1.$CSPScripts,
    $AppIdConfig: app_id_config_1.$AppIdConfig,
    $Crawler: crawler_1.$Crawler,
    $DOMReadyState: dom_1.$DOMReadyState,
    $InstalledRelatedApp: installed_related_app_1.$InstalledRelatedApp,
    $Location: remix_1.$Location,
    $SearchParams: remix_1.$SearchParams,
    $ServerContext: server_context_1.$ServerContext,
    $ABTest: ab_test_1.$ABTest,
    $AdditionalScripts: additional_scripts_1.$AdditionalScripts,
    $USPreBanState: us_pre_ban_state_1.$USPreBanState,
    $FallbackGpToApk: fallback_gp_to_apk_1.$FallbackGpToApk,
};
exports.BuiltinWritableAtoms = {
    $I18nText: i18n_text_1.$I18nText,
    $WebUser: web_user_1.$WebUser,
    $RenderConfig: render_config_1.$RenderConfig,
    $Locale: locale_1.$Locale,
    $UserAgent: user_agent_1.$UserAgent,
    $EnterABTest: ab_test_1.$EnterABTest,
    $CurrentABTest: ab_test_1.$CurrentABTest,
    $RootTraffic: root_traffic_1.$RootTraffic,
    $CSPScripts: csp_scripts_1.$CSPScripts,
    $AppIdConfig: app_id_config_1.$AppIdConfig,
    $Crawler: crawler_1.$Crawler,
    $DOMReadyState: dom_1.$DOMReadyState,
    $InstalledRelatedApp: installed_related_app_1.$InstalledRelatedApp,
    $Location: remix_1.$Location,
    $SearchParams: remix_1.$SearchParams,
    $ServerContext: server_context_1.$ServerContext,
    $AdditionalScripts: additional_scripts_1.$AdditionalScripts,
    $USPreBanState: us_pre_ban_state_1.$USPreBanState,
    $FallbackGpToApk: fallback_gp_to_apk_1.$FallbackGpToApk,
};
